import OnlineTestInstructions from "../../components/views/online_tests/OnlineTestInstructions";
import OnlineTestView from "../../components/views/online_tests/OnlineTestView";
import LoadingTestView from "../../components/views/online_tests/LoadingTestView";

export const onlineTestRoutes = [
  { path: '/online-tests/:key/instructions', component: OnlineTestInstructions, meta: {title: "Instruções da prova"}},
  { path: '/online-tests/:key/test', component: OnlineTestView, meta: {title: "Prova Online"}},
  { path: '/online-tests/:key/loading', component: LoadingTestView, meta: {title: "Tela de Carregamento"}},
];
